import { render } from "./Wave.vue?vue&type=template&id=b0a37f06"
import script from "./Wave.vue?vue&type=script&lang=js"
export * from "./Wave.vue?vue&type=script&lang=js"

import "./Wave.vue?vue&type=style&index=0&id=b0a37f06&lang=scss"
script.render = render

export default script